/**
 * Inserts some help text under the answer block of the current panel (i.e. below the button)
 * @param {Element} form
 * @param {*} html - The HTML content or text to render. Set to blank to remove the help text
 */
export default function setHelpText(form, html) {
  const answerBlock = form.querySelector(
    '.lead-constructor__panel.active .lead-constructor__answer-block'
  );

  // Remove any existing help text
  let p = answerBlock.nextElementSibling;
  if(p.tagName === 'P') answerBlock.parentNode.removeChild(p);

  if(html) {
    // Insert new help text
    p = document.createElement('P');
    p.innerHTML = html;
    answerBlock.parentNode.insertBefore(p, answerBlock.nextElementSibling);
  }
}
